export function applyHeight(imgElement){  
    // applica per i schermi maggiori di md
    if (window.innerWidth >= 768) {
        console.log("Applicazione altezza per schermi maggiori di 768px");
   
            let imgElement = document.querySelector('.img-bg');
            // Ottieni le dimensioni dell'immagine
            let imgWidth = imgElement.width || imgElement.offsetWidth;
            let imgHeight = imgElement.height || imgElement.offsetHeight;
            
            // Se non abbiamo dimensioni, prova a usare gli attributi width e height
            if (!imgWidth) imgWidth = imgElement.getAttribute('width');
            if (!imgHeight) imgHeight = imgElement.getAttribute('height');
            
            // Converti in numeri se sono stringhe
            imgWidth = parseFloat(imgWidth);
            imgHeight = parseFloat(imgHeight);
            
            console.log('Dimensioni immagine:', imgWidth, 'x', imgHeight);
            
            // Calcola l'altezza proporzionale in base alla larghezza dello schermo
            let scaledHeight = (imgHeight / imgWidth) * window.innerWidth;
            console.log("Immagine caricata");
            console.log('Altezza calcolata:', scaledHeight);
            
            // Trova tutte le sezioni che devono essere ridimensionate
            const sections = document.querySelectorAll(".heigthsection");
            console.log('Sezioni trovate:', sections.length);
            
            // Applica l'altezza a ciascuna sezione
            sections.forEach((section, index) => {
                console.log(`Applicando altezza alla sezione ${index + 1}`);
                // prendi data index della sezione
                const dataIndex = section.getAttribute('data-index');
                console.log(`Data index della sezione: ${dataIndex}`);
                
                if(dataIndex === '2') {
                   section.classList.add('lg:pt-0'); // Aggiungi la classe lg:pt-0 alla sezione con data-index 2
                } 
                
                // Applica l'altezza solo se NON è la sezione 5 o se siamo su schermi grandi
                if(dataIndex !== '5' && dataIndex !== 5) {
                    section.style.height = scaledHeight + 'px';
                    
                    // Opzionale: personalizza l'altezza per sezioni specifiche
                    if (section.hasAttribute('data-height-offset')) {
                        const offset = parseInt(section.getAttribute('data-height-offset'), 10) || 0;
                        section.style.height = (scaledHeight + offset) + 'px';
                    }
                } 
                // Gestisci separatamente la sezione 5
                else {
                    if(window.innerWidth < 1400) {
                        console.log("Sezione con data-index 5, altezza non applicata per schermi piccoli");
                        
                        // Rimuovi la proprietà height inline
                        section.style.removeProperty('height');
                        
                        // Imposta esplicitamente l'altezza a 'auto' con !important
                        section.style.setProperty('height', 'auto', 'important');
                        
                        // Aggiungi una classe specifica per il controllo tramite CSS
                        section.classList.add('no-fixed-height');
                        
                        // Verifica che le modifiche siano state applicate
                        console.log("Height style dopo modifica:", section.style.height);
                        console.log("Computed style dopo modifica:", window.getComputedStyle(section).height);
                    } else {
                        // Se lo schermo è grande (>=1400px), applica l'altezza normale
                        section.style.height = scaledHeight + 'px';
                        
                        if (section.hasAttribute('data-height-offset')) {
                            const offset = parseInt(section.getAttribute('data-height-offset'), 10) || 0;
                            section.style.height = (scaledHeight + offset) + 'px';
                        }
                    }
                }
            });
            
            // Aggiorna le altezze quando la finestra cambia dimensione
            window.addEventListener('resize', function() {
                const newScaledHeight = (imgHeight / imgWidth) * window.innerWidth;
                
                sections.forEach((section) => {
                    section.style.height = newScaledHeight + 'px';
                    
                    if (section.hasAttribute('data-height-offset')) {
                        const offset = parseInt(section.getAttribute('data-height-offset'), 10) || 0;
                        section.style.height = (newScaledHeight + offset) + 'px';
                    }
                });
            });
        
     } else {
        console.log("Schermo troppo piccolo, altezza non applicata");
        return; // Esci se lo schermo è troppo piccolo
    }
}
